var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RouterView'),(!_vm.pagesWithoutTopBar.includes(_vm.$route.name))?_c('TopBar'):_vm._e(),(!_vm.pagesWithoutFooterContact.includes(_vm.$route.name))?_c('FooterContact'):_vm._e(),(!_vm.pagesWithoutFooter.includes(_vm.$route.name))?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }